import styled from 'styled-components';

import { IllustrationSpotError } from '@xing-com/illustrations';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  cornerRadiusL,
  scale000,
  space3XL,
  space4XL,
  space5XL,
  spaceL,
  spaceS,
  spaceXL,
  spaceXXL,
  xdlColorBackgroundSecondary,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: ${cornerRadiusL};
  background: ${xdlColorBackgroundSecondary};
  padding: ${space3XL};
  margin: ${space5XL} ${scale000};

  @media ${mediaSmallOrTiny} {
    padding: ${spaceXXL};
    margin: ${space4XL} ${scale000};
  }
`;

const StyledIllustrationSpotError = styled(IllustrationSpotError)`
  height: ${space5XL};
  width: ${space5XL};

  @media ${mediaSmallOrTiny} {
    height: ${space4XL};
    width: ${space4XL};
  }
`;

const StyledHeadline = styled(Headline)`
  margin: ${spaceXL} ${scale000} ${spaceS};

  @media ${mediaSmallOrTiny} {
    margin-top: ${spaceL};
  }
`;

const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: ${spaceL};
`;

export const Styled = {
  Wrapper,
  IllustrationSpotError: StyledIllustrationSpotError,
  Headline: StyledHeadline,
  BodyCopy: StyledBodyCopy,
};
